interface OptimizedImageAsset {
  height: number;
  sources: Array<{
    srcSet: string;
    type: "image/webp";
  }>;
  src: string;
  width: number;
}

const imageAssets: Record<string, OptimizedImageAsset> = {
  "/Forest-Photos/Forest-1.png": {
    height: 1024,
    sources: [
      {
        srcSet:
          "/optimized/forest-1-768.webp 768w, /optimized/forest-1-1280.webp 1280w, /optimized/forest-1-1536.webp 1536w",
        type: "image/webp",
      },
    ],
    src: "/optimized/forest-1-1280.webp",
    width: 1536,
  },
  "/Forest-Photos/Forest-2.png": {
    height: 1024,
    sources: [
      {
        srcSet:
          "/optimized/forest-2-768.webp 768w, /optimized/forest-2-1280.webp 1280w, /optimized/forest-2-1536.webp 1536w",
        type: "image/webp",
      },
    ],
    src: "/optimized/forest-2-1280.webp",
    width: 1536,
  },
  "/Forest-Photos/Forest-3.png": {
    height: 1024,
    sources: [
      {
        srcSet:
          "/optimized/forest-3-768.webp 768w, /optimized/forest-3-1280.webp 1280w, /optimized/forest-3-1536.webp 1536w",
        type: "image/webp",
      },
    ],
    src: "/optimized/forest-3-1280.webp",
    width: 1536,
  },
  "/Forest-Photos/Forest-4.png": {
    height: 1024,
    sources: [
      {
        srcSet:
          "/optimized/forest-4-768.webp 768w, /optimized/forest-4-1280.webp 1280w, /optimized/forest-4-1536.webp 1536w",
        type: "image/webp",
      },
    ],
    src: "/optimized/forest-4-1280.webp",
    width: 1536,
  },
  "/Beach-Photos/Beach-1.png": {
    height: 941,
    sources: [
      {
        srcSet:
          "/optimized/beach-1-768.webp 768w, /optimized/beach-1-1280.webp 1280w, /optimized/beach-1-1672.webp 1672w",
        type: "image/webp",
      },
    ],
    src: "/optimized/beach-1-1280.webp",
    width: 1672,
  },
  "/Beach-Photos/Beach-2.png": {
    height: 941,
    sources: [
      {
        srcSet:
          "/optimized/beach-2-768.webp 768w, /optimized/beach-2-1280.webp 1280w, /optimized/beach-2-1672.webp 1672w",
        type: "image/webp",
      },
    ],
    src: "/optimized/beach-2-1280.webp",
    width: 1672,
  },
  "/Beach-Photos/Beach-3.png": {
    height: 1024,
    sources: [
      {
        srcSet:
          "/optimized/beach-3-768.webp 768w, /optimized/beach-3-1280.webp 1280w, /optimized/beach-3-1536.webp 1536w",
        type: "image/webp",
      },
    ],
    src: "/optimized/beach-3-1280.webp",
    width: 1536,
  },
  "/Beach-Photos/Beach-4.png": {
    height: 1024,
    sources: [
      {
        srcSet:
          "/optimized/beach-4-768.webp 768w, /optimized/beach-4-1280.webp 1280w, /optimized/beach-4-1536.webp 1536w",
        type: "image/webp",
      },
    ],
    src: "/optimized/beach-4-1280.webp",
    width: 1536,
  },
};

export function getOptimizedImageAsset(
  src: string,
): OptimizedImageAsset | undefined {
  return imageAssets[src];
}

export function buildUnsplashSrcSet(
  src: string,
  widths: readonly number[],
): string | undefined {
  try {
    const imageUrl = new URL(src);

    if (imageUrl.hostname !== "images.unsplash.com") {
      return undefined;
    }

    return widths
      .map((width) => {
        const sizedUrl = new URL(src);
        sizedUrl.searchParams.set("w", String(width));

        return `${sizedUrl.toString()} ${String(width)}w`;
      })
      .join(", ");
  } catch {
    return undefined;
  }
}
